import React from "react"
import { Footer, Main } from "../styles"
import { useTurn } from "../../shared/hooks/useTurn"
import { Players } from "../players/Players"
import styled from "styled-components"
import getMediaUrl from "../../../utils/mediaUrl"

const MessageDiv = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TurnIntro = props => {
  const { error, roundData, turnData, labels, gameProps } = useTurn()
  if (error) return <div>{error}</div>

  const turn_player_title = turnData?.turn_role_if_normal?.title || ""
  const turn_status = `${turn_player_title} ${labels.turn_player_draws_card}`

  const backgroundImage =
    turnData?.turn_host_screen?.host_background_image ||
    roundData?.host_background_image
  const backgroundImageUrl = getMediaUrl(
    gameProps?.strapiUrl,
    backgroundImage?.url
  )
  const imageAlt = backgroundImage?.alternativeText || ""

  const message = (
    <MessageDiv>
      <div>{turn_status}</div>
    </MessageDiv>
  )

  return (
    <Main backgroundImage={backgroundImageUrl} role="img" aria-label={imageAlt}>
      <Footer>
        <Players message={message} />
      </Footer>
    </Main>
  )
}
